var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rgs-navigation-section"},_vm._l((_vm.children),function(section){return _c('navigation-section',_vm._b({key:section.id},'navigation-section',section,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }